import React, { useEffect, useState } from 'react';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import { Divider, ListItemButton, Stack, Typography, Box } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { useSnackbar } from '../../../context/SnackbarContext';
import { useTranslation } from 'react-i18next';
import InfoIcon from '@mui/icons-material/Info';
import { getAppInfo } from '../../../api/authService';
import packageJson from '../../../../package.json'; 
import logo from '../../../logo-wide.png';

export default function AppInfo() {
    const { t } = useTranslation('common'); 
    const [open, setOpen] = React.useState(false);
    const { showSnackbar } = useSnackbar();

    const handleClickOpen = () => setOpen(true);
    const handleClose = () => {
        setOpen(false);
    };

    const [appInfo, setAppInfo] = useState(null);

    useEffect(() => {
      const fetchData = async () => {
        const data = await getAppInfo();
        setAppInfo(data);
      };
      fetchData();
    }, []);

    return (
        <React.Fragment>
        <ListItem>
            <ListItemButton onClick={handleClickOpen}>
            <ListItemIcon>
                <InfoIcon fontSize='large' color='secondary'/>
            </ListItemIcon>
            <ListItemText 
                primary="App Info"
                secondary="view app information"
            />
            </ListItemButton>
        </ListItem>

        <Dialog onClose={handleClose} open={open} disableRestoreFocus>
            <DialogTitle>
            App Information
            </DialogTitle>
            <DialogContent
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",     // horizontal centering
                justifyContent: "center", // vertical centering
              }}
            >
              <Box
                component="img"
                src={logo}
                alt="Animora Vet Hub"
                sx={{
                  height: 80,
                  objectFit: 'contain',
                }}
              />
              <Typography textAlign={'right'} variant='body2'>API version: {appInfo?.apiVersion}</Typography>
              <Typography textAlign={'right'} variant='body2'>App version: {packageJson?.version}</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Close</Button>
            </DialogActions>
        </Dialog>
        </React.Fragment>
    );
}